export default __webpack_public_path__ + "static/img8@2x-38ede597ba2c14f79ba39da898487374.jpg";